module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/minus-b5f2fd2460ab9b8bc493f5f480a2c658.svg";